<!-- Button to Open Popup -->
<div class="col-lg-2">
  <button type="button" class="btn btn-outline-dark" (click)="openPopup()">Master</button>
</div>

<!-- Backdrop Overlay for Dim Effect -->
<div *ngIf="isPopupVisible" class="overlay"></div>

<!-- Popup Component (Pass closePopup function) -->
<app-popup-in *ngIf="isPopupVisible" [closePopup]="closeMasterPopup.bind(this)"></app-popup-in>

<div class="container-fluid">
  <button class="close-btn" (click)="onClose()">
    <i class="feather icon-x"></i> <!-- Cross icon -->
  </button>
<div class="row justify-content-center">
    <div>
      <div>
        <div class="card-body">
          <div class="mb-4 d-md-flex align-items-center justify-content-center">
            <div>
              <h4>Add Material Form</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <form [formGroup]="addInvenMaterial" (ngSubmit)="addInventory()">
                <div class="row">
                  <div class="col form-group mb-3">
                    <label for="category" class="form-label">Category</label>
                    <select formControlName="category" id="category" class="form-control custom-select" (change)="updateSubcategories($event.target.value)">
                      <option value="" disabled selected>Select category</option>
                      <option *ngFor="let category of categoryOptions" [value]="category">{{ category }}</option>
                    </select>
                  </div>
                  
                  <div class="col form-group mb-3">
                    <label for="subcategory" class="form-label">Subcategory</label>
                    <select formControlName="subcategory" id="subcategory" class="form-control custom-select">
                      <option value="" disabled selected>Select subcategory</option>
                      <option *ngFor="let subcategory of subcategoryOptions" [value]="subcategory">{{ subcategory }}</option>
                    </select>
                  </div>
                  

                  
                  <!-- Conditional input fields for Rolls/Films category -->
                <div *ngIf="addInvenMaterial.get('category').value === 'Rolls'|| addInvenMaterial.get('category').value === 'Films'" class="row">
                  <div class="col form-group mb-3">
                    <label for="thicknessMicron" class="form-label">Thickness in Micron</label>
                    <input type="text" formControlName="thicknessMicron" id="thicknessMicron" class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                    <label for="sizeMM" class="form-label">Size in MM</label>
                    <input type="text" formControlName="sizeMM" id="sizeMM" class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                    <label for="rollNo" class="form-label">Roll No</label>
                    <input type="text" formControlName="rollNo" id="rollNo" class="form-control" />
                  </div>
                </div>

                <!-- Conditional input fields for Inks/Solvent category -->
                <div *ngIf="addInvenMaterial.get('category').value === 'Inks'|| addInvenMaterial.get('category').value === 'Solvent'" class="row">
                  <div class="col form-group mb-3">
                    <label for="color" class="form-label">Color</label>
                    <input type="text" formControlName="color" id="color" class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                    <label for="inkType" class="form-label">Ink Type</label>
                    <input type="text" formControlName="inkType" id="inkType" class="form-control" />
                  </div>
                </div>
                  <div class="col form-group mb-3">
                    <label for="materialTypeGrade" class="form-label">Material Type/Grade</label>
                    <input type="text" formControlName="materialTypeGrade" id="materialTypeGrade" class="form-control" />
                  </div>
                  
                </div>
                <!-- <div class="row">
                  <div class="col form-group mb-3">
                    <label for="material" class="form-label">Material</label>
                    <input type="text" formControlName="material" id="material" class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                    <label for="submaterial" class="form-label">Submaterial</label>
                    <input type="text" formControlName="submaterial" id="submaterial" class="form-control" />
                  </div>
                </div> -->
                <div class="row">
                 
                  <div class="col form-group mb-3">
                    <label for="supplier" class="form-label">Supplier</label>
                    <input type="text" formControlName="supplier" id="supplier" class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                    <label for="receivedDate" class="form-label">Received Date</label>
                    <input type="date" formControlName="receivedDate" id="receivedDate" class="form-control" />
                  </div>
                </div>
                <div class="row">
                  
                  <div class="col form-group mb-3">
                    <label for="materialDescription" class="form-label">Material Description</label>
                    <input type="text" formControlName="materialDescription" id="materialDescription" class="form-control" readonly/>
                  </div>
                </div>
                <div class="row">
                  <div class="col form-group mb-3">
                    <label for="qty" class="form-label">Qty (Kg)</label>
                    <input type="text" formControlName="qty" id="qty" class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                    <label for="location" class="form-label">Location</label>
                    <input type="text" formControlName="location" id="location" class="form-control" />
                  </div>
                </div>
              

                <div class="text-end">
                  <button type="submit" class="btn btn-outline-dark">{{ isUpdateMode ? 'Update': 'Submit' }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  